module.exports = __webpack_public_path__ + "media/images/flags/ec-ae28d58e2a276ff03ab9d52daf118406.svg";